var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BaseTopLine'),_c('div',{staticClass:"p-20"},[_c('div',{staticClass:"chart-container"},[_c('LineChartGenerator',{attrs:{"chart-options":_vm.chartOptions,"chart-data":_vm.chartData}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }